export default process.env.JEST_WORKER_ID !== undefined;
